import api from "./index";

export async function getRaffles(params) {
  return api.get("/raffles", { params });
}

export async function getRaffleID(raffleID) {
  return api.get(`/raffles/${raffleID}`);
}

export async function joinRaffle(raffleID, body) {
  return api.post(`/raffles/${raffleID}/collect`, body);
}

export async function getRaffleTokens(params) {
  return api.get(`/raffles/tokens`, { params });
}

export async function getRafflesTokensCount(personID) {
  return api.get(`/raffles/people/${personID}/tokens/count`);
}

export async function getEligibility(raffleID, personID) {
  return api.get(`/raffles/${raffleID}/people/${personID}/eligibility`);
}

export async function getRafflesWinners(params) {
  return api.get(`/raffles/winners`, { params });
}

export async function getTokensRequests(params) {
  return api.get(`/raffles/tokens/requests`, { params });
}

export async function exportTokens(raffleID, params) {
  return api.get(`/raffles/${raffleID}/tokens/export`, {
    params,
    responseType: "blob",
  });
}

export async function getRaffleLuckyTokens(raffleID) {
  return api.get(`/raffles/${raffleID}/lucky-tokens`);
}
